import { render } from "./table-pagination.vue?vue&type=template&id=1caa762d"
import script from "./table-pagination.vue?vue&type=script&lang=js"
export * from "./table-pagination.vue?vue&type=script&lang=js"

import "./table-pagination.vue?vue&type=style&index=0&id=1caa762d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__